import { render } from "./CustomProperties.vue?vue&type=template&id=5e1e2ab1"
import script from "./CustomProperties.vue?vue&type=script&lang=js"
export * from "./CustomProperties.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__